import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useSearchHandler from 'hooks/useSearchHandler';

import { Container } from 'components/core/Page';
import { Paragraph } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';

import MapPin from 'components/svg/MapPin';

import './SearchSection.scss';

export function SearchSection({
	className,
	title = 'Search for storage units near you',
	searchParams,
	location,
	type,
}) {
	const [searchType, setSearchType] = useState('storage');
	const [searchAmenities, setSearchAmenities] = useState([]);

	const handleSearchAmenitiesChange = (value) => {
		if (value === 'vehicle') {
			setSearchType('vehicle');
		} else {
			setSearchType(null);
			setSearchAmenities(value);
		}
	};

	const additionalSearchParams = useMemo(() => {
		const amenityBoolean =
			searchAmenities && typeof searchAmenities === 'string'
				? { [searchAmenities]: true }
				: {};
		return {
			type: searchType,
			amenities: [searchAmenities],
			filtered: !!searchAmenities,
			...amenityBoolean,
			...searchParams,
		};
	}, [searchType, searchAmenities, searchParams]);

	const handleSearch = useSearchHandler({
		searchType,
		additionalSearchParams,
		type,
		location,
	});

	return (
		<Container className={classnames('search-hero', className)}>
			<Paragraph
				size="small"
				weight="extraBold"
				color="secondaryBlue"
			>
				{title}
			</Paragraph>
			<div className="hero-form-content">
				<SearchBox
					setSearchAmenities={handleSearchAmenitiesChange}
					defaultButton={false}
					icon={<MapPin />}
					onSearch={handleSearch}
					id="hero-search"
					inputLabel="Enter ZIP Code or City Name"
					useBrowserLocation
				/>
			</div>
		</Container>
	);
}

SearchSection.propTypes = {
	title: PropTypes.string,
	className: PropTypes.string,
	searchParams: PropTypes.object,
	location: PropTypes.string,
	type: PropTypes.string,
};

export default SearchSection;
